export enum QuoteProjectSizeEnum {
  SMALL,
  MEDIUM,
  LARGE
}

export enum QuoteClassificationEnum {
  CLASS_1 = 1,
  CLASS_2 = 2,
  CLASS_3 = 3
}

export enum QuoteSurchargeApplicationTypeEnum {
  None,
  Mandatory,
  All
}
